// src/i18n-config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importiere die Übersetzungsdateien
import translationDE from './locales/de.json';
import translationEN from './locales/en.json';

const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  }
};

i18n
  // Erkennt die Browsersprache
  .use(LanguageDetector)
  // Übergibt i18n an react-i18next
  .use(initReactI18next)
  // Initialisiert i18next
  .init({
    resources,
    fallbackLng: 'de', // Fallback-Sprache, wenn die Erkennung fehlschlägt
    debug: true, // (In Produktion auf 'false' setzen)
    interpolation: {
      escapeValue: false // React macht das bereits
    },
    // Deaktiviere das automatische Laden von 'en-US' etc.
    // Wir wollen nur 'en' oder 'de'
    load: 'languageOnly' 
  });

export default i18n;